var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25.009,
    viewBox: "0 0 25 25.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "offer_tag",
    transform: "translate(-765 -824.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8514",
    "data-name": "Path 8514",
    d: "M28.167,52.5h-5.93a2.592,2.592,0,0,0-1.833.759L8.549,65.109a.864.864,0,0,0,0,1.222l7.943,7.943a.864.864,0,0,0,1.222,0L29.568,62.419a2.592,2.592,0,0,0,.759-1.833V54.655a2.16,2.16,0,0,0-2.16-2.155Zm-.38,4.373a1.3,1.3,0,1,1,0-1.833,1.3,1.3,0,0,1,0,1.833Z",
    transform: "translate(757.109 775.068)",
    fill: "#ff4f04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8515",
    "data-name": "Path 8515",
    d: "M9.846,66.407,21.7,54.552a2.592,2.592,0,0,1,1.833-.759h5.931a2.141,2.141,0,0,1,.729.135A2.154,2.154,0,0,0,28.167,52.5h-5.93a2.592,2.592,0,0,0-1.833.759L8.549,65.11a.864.864,0,0,0,0,1.222l1.3,1.3a.864.864,0,0,1,0-1.225Z",
    transform: "translate(757.109 775.067)",
    fill: "#ff4f04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8516",
    "data-name": "Path 8516",
    d: "M25,1.708A1.7,1.7,0,0,0,22.093.5c-.137.137-.385.432-.521.6a.4.4,0,1,0,.623.517c.213-.257.389-.459.471-.541A.9.9,0,0,1,23.3.815h0a.883.883,0,0,1,.886.889.9.9,0,0,1-.266.637,14.472,14.472,0,0,1-1.431,1.1,2.566,2.566,0,0,0-2.215-1.274H14.346a2.978,2.978,0,0,0-2.119.878L.372,14.9a1.269,1.269,0,0,0,0,1.8l7.943,7.943a1.271,1.271,0,0,0,1.8,0l11.854-11.86a2.978,2.978,0,0,0,.878-2.119V4.728a2.564,2.564,0,0,0-.051-.511,15.5,15.5,0,0,0,1.7-1.3A1.706,1.706,0,0,0,25,1.708Zm-2.968,3.02v5.931a2.173,2.173,0,0,1-.641,1.547L9.536,24.06a.46.46,0,0,1-.649,0L.945,16.117a.459.459,0,0,1,0-.649L12.8,3.613a2.173,2.173,0,0,1,1.547-.641h5.931a1.757,1.757,0,0,1,1.544.921c-.478.317-1.014.654-1.582.985l-.055-.057a1.7,1.7,0,1,0,.441.769c.494-.288.969-.582,1.407-.866a.006.006,0,0,0,0,0ZM18.619,6.206a.4.4,0,0,0,.544.18q.356-.179.708-.371A.891.891,0,1,1,19.5,5.3q-.344.187-.7.365a.4.4,0,0,0-.181.541Z",
    transform: "translate(765 824.995)",
    fill: "#ff4f04"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferTag);
export default __webpack_public_path__ + "static/media/offer_tag.b756559b5265e0ad13653af931362861.svg";
export { ForwardRef as ReactComponent };